import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCar} from '@fortawesome/free-solid-svg-icons';
import {DealerInfo} from '../../models/dealership.model';
import {getFromStore, StorePath} from '../../services/store.service';
import {Settings} from '../../models/snippet-payload.model';

const Avatar = () => {
    const dealerInfo: DealerInfo = getFromStore(StorePath.DEALER_INFO) as DealerInfo;
    const settings: Settings = getFromStore(StorePath.SETTINGS) as Settings;
    let oemLogo: string = settings?.logo_url || dealerInfo?.oems?.[0] || '';
    const resetOemLogo = () => {
        oemLogo = '';
    };

    return (
        <div className="flex rounded-full bg-gray-100 text-xs grow-0 shrink-0 mr-[8px] w-[32px] h-[32px]
             justify-center items-center self-end">
            {oemLogo && <img className="oem-logo" src={oemLogo} alt="logo" onError={resetOemLogo} />}
            {!oemLogo && <FontAwesomeIcon icon={faCar} className="text-gray-700" />}
        </div>
    );
};

export default Avatar;
